var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyHoldersWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property_Holders-white",
    "data-name": "Property Holders-white",
    transform: "translate(-1459 -447)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    width: 24,
    height: 24,
    transform: "translate(1459 447)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M8,13c-2.333,0-7,1.167-7,3.5V19H15V16.5c0-2.333-4.666-3.5-7-3.5m8,0a9.526,9.526,0,0,0-.966.054A4.206,4.206,0,0,1,17,16.5V19h6V16.5c0-2.333-4.665-3.5-7-3.5M8,5a3,3,0,1,0,2.991,3A3,3,0,0,0,8,5m8,0A3,3,0,1,0,18.99,8,3,3,0,0,0,16,5",
    transform: "translate(1459 447)",
    fill: "current",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyHoldersWhite);
export default __webpack_public_path__ + "static/media/Property-Holders-white.9648de78358cd453bdc0f1bad6b15555.svg";
export { ForwardRef as ReactComponent };